import '../internals/sentry/initSentryService';

import { createRoot, Root } from 'react-dom/client';

import { loadWebManifest } from './scripts/manifestLoader';
import { App } from './App';

loadWebManifest();
const root: Root = createRoot(document.getElementById('root') as Element);

root.render(<App />);
